import React, { useEffect } from "react";
import { authContext } from "auth/adalConfig";
import LoadingSpinner from "components/loadingSpinner";

export const Loading = ({setLoading, setError}) => {
  useEffect(() => {
    const timer = setInterval(() => {
      if (authContext?._user) {
        setLoading(true);
      }
      else {
        const errorMsg = localStorage.getItem('adal.error.description'); 
        if (errorMsg) {
          setError(errorMsg);
        }
      }
    }, 200);
    return () => clearInterval(timer);
  }, [authContext]);

  return (
    <h3 className="loading" style={{padding: "20px"}}>
      <span>Loading</span>
      <span style={{paddingLeft: "10px"}}><LoadingSpinner /></span>
    </h3>
  );
}